import React from "react";

// Components
import VenueListItem from "./VenueListItem";

const VenueList: React.FC<any> = (props: any) => {
  const className = {
    width: props.venues?.length < 4 ? "col col-lg-6 col-md-12 col-sm-12 col-12 p-0" : "col col-lg-12 col-md-12 col-sm-12 col-12 p-0",
    row: props.venues?.lengty < 4 ? "list-group mt-3" : "row",
    column: props.venues?.length < 4 ? "col-12 col-md-12" : "col-12 col-md-6"
  }
  
  return (
    <main role="main" className="container pt-2 pt-lg-4">
      <div className="row justify-content-center p-3">
        <div className={className.width}>
          <div className="text-center">
            <h1 className="medium-title">
              Ocupació dels nostres recintes en temps real
            </h1>
          </div>

          <div className={className.row}>
            {props.venues &&
              props.venues.map((venue: any, i: number) => {
                return (
                  <div key={i} className={className.column}>
                    {" "}
                    <VenueListItem
                      {...props}
                      venue={venue}
                    />{" "}
                  </div>
                );
              })}
          </div>

      
          <div className="text-center">
            <button
              type="button"
              className="btn blue1 normal-text"
              onClick={() => props.setRefresh((refresh: number) => new Date().getTime())}
            >
              Actualitzat per darrera vegada a les {new Date().toLocaleTimeString(navigator.language, {hour:"2-digit", minute: "2-digit"})}. Clica aquí per actualitzar les dades.
            </button>
          </div>
        </div>
      </div>
    </main>
  );
};

export default VenueList;
